module.exports = __webpack_public_path__ + "img/avatar_model_y.eabae17d.png";